// extracted by mini-css-extract-plugin
export var section = "_2t-1";
export var topNav = "_2t-0";